import React, { useState, Component, useRef} from "react";

import {
    createStyles,
    Text,
    Avatar,
    TypographyStylesProvider,
    Paper,
    ActionIcon,
    Image,
    Group,
    Card,
    Button,
    NumberInput,
    ColorPicker,
    TextInput,
    PasswordInput,
    Textarea,
    Collapse,
    Stack
} from '@mantine/core';
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { DatePicker } from '@mantine/dates';
import {
    IconShieldLock,
    IconCornerDownRight,
    IconSquareRoundedArrowUp,
    IconTrendingUp,
    IconCheck,
    IconBell,
    IconChevronDown,
    IconPencil,
} from '@tabler/icons';
import pagani from '../assets/pagani.jpg';
const useStyles = createStyles((theme) => ({
    dzBtn: {
        margin: '0 auto',
        width: '100%'
    }
}));


//descript:modal for editing basic info about the site
//needed:styling
//needed:state integration and api calls
//needed:params to separate different account types
const AccntMgmtEdit = props => {
    const { classes } = useStyles();
    //needed:'openSection' catch-all function that sets states based upon the event name 
    const [securitySect, setSecuritySectOpen] = useState(false);
    const [resetPwSect, setResetPwSectOpen] = useState(false);
    const [alertPrefSect, setAlertPrefSectOpen] = useState(false);
    const iconSize = 22;
    
    return (
        <>
            <Card shadow="sm" p="lg" radius="md">
                <Card.Section>
                    <Stack align="center">
                        <Avatar
                            src={pagani}
                            radius="48px"
                            size={"xl"}
                        />
                        <br/>
                        <Dropzone
                            multiple={false}
                            accept={IMAGE_MIME_TYPE}
                            className={classes.dzBtn}
                        >
                            <Button
                                fullWidth={true}
                                leftIcon={<IconPencil size={iconSize}/>}
                            >
                            Avatar
                            </Button>
                        </Dropzone>
                    </Stack>
                </Card.Section>
                <br/>
                <Card.Section>
                    <TextInput
                        placeholder="How you appear to other users"
                        label="Username"
                    />
                    <DatePicker
                        placeholder="D.O.B."
                        label="Date Of Birth"
                        initialLevel="year"
                    />
                </Card.Section>

                <br/>
                <br/>
                <Card.Section>
                
                    <Button
                        onClick={() => setAlertPrefSectOpen((o) => !o)}
                        color="yellow"
                        fullWidth
                        leftIcon={<IconBell size={iconSize}/>}
                    >
                    Alert Preferences
                    </Button>
                    <br/>
                    <Collapse in={alertPrefSect} transitionDuration={1000} transitionTimingFunction="linear">
                        {/*needed: checkboxes for each preference(make it a component)*/}
                        <TextInput
                            placeholder="Email for notifs"
                            label="Email"
                        />
                        <TextInput
                            placeholder="Number for SMS Alerts"
                            label="Phone Number"
                        />
                    </Collapse>
                </Card.Section>
                <br/>
                <Card.Section>
                    <Button
                        onClick={() => setSecuritySectOpen((o) => !o)}
                        color="red"
                        fullWidth
                        leftIcon={<IconShieldLock size={iconSize}/>}
                    >
                    Password Management
                    </Button>
                    <Collapse in={securitySect} transitionDuration={1000} transitionTimingFunction="linear">
                        <PasswordInput
                            placeholder="Account's Current Password"
                            label="Current Password:"
                            withAsterisk
                        />
                        <br/>
                        <Button
                            onClick={() => setResetPwSectOpen((o) => !o)}
                            color="blue"
                            leftIcon={<IconChevronDown size={iconSize}/>}
                        >
                        Reset Password
                        </Button>
                    </Collapse>
                    <Collapse in={resetPwSect} transitionDuration={1000} transitionTimingFunction="linear">
                        <PasswordInput
                            placeholder="Account's New Password"
                            label="New Password:"
                            withAsterisk
                        />
                        <PasswordInput
                            placeholder="Account's New Password"
                            label="Confirm New Password:"
                            withAsterisk
                        />
                        <br/>
                        <Button
                            disabled={false}
                            color="green"
                            leftIcon={<IconCheck size={iconSize}/>}
                        >
                        Reset
                        </Button>
                    </Collapse>
                </Card.Section>
            </Card>
        </>
    )
};
export default AccntMgmtEdit
